import { IHistoricData } from '../app/models/deployLogger';
import { LogMessagesMock } from './log-messages';
import { ProcessStatusesTestMock } from './statuses';

export const MonitoringHistoricalDataMock: IHistoricData = {
	stage: ProcessStatusesTestMock,
	logs: LogMessagesMock,
};
